var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.033 4.41L.758 2.028 0 2.822 3.033 6 8 .795 7.242 0l-4.21 4.41z","fill":"#067D7D"}));
}

Check.defaultProps = {"width":"8","height":"6","viewBox":"0 0 8 6","fill":"none"};

module.exports = Check;

Check.default = Check;
